import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import { paletteV2 } from '../../../theme/palette';

/**
 * @todo palette overhaul - migrate to palette namespace
 */

export type ColorVariant = keyof typeof paletteV2;

export interface ColorIconProps {
  variant?: 'sm' | 'md';
  color?: ColorVariant | string;
  children?: React.ReactNode;
}

const useStyles = makeStyles()(theme => ({
  fontSizeMd: {
    fontSize: '15px',
  },
  fontSizeSm: {
    fontSize: '12px',
  },
}));

const ColorIcon = (props: ColorIconProps) => {
  const { classes } = useStyles();
  const { variant = 'sm', color, children } = props;
  const fontSize = variant === 'md' ? classes.fontSizeMd : classes.fontSizeSm;

  const textColorShade = 600;
  const backgroundColorShade = 200;

  /**
   * Let default be hex color + black text color
   * If color prop is actually a paletteV2 key, then we can map to appropriate colors
   */
  let backgroundColor = paletteV2.panda[200];
  let textColor = 'black';

  const isHexCode = color?.charAt(0) === '#';
  const hexRegex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

  if (color && !isHexCode) {
    Object.entries(paletteV2).forEach(value => {
      const name = value.at(0);
      const values: Record<number, string> = value.at(1);
      if (name !== color) return;
      backgroundColor = values[backgroundColorShade];
      textColor = values[textColorShade];
    });
  }
  if (color && hexRegex.test(color)) {
    backgroundColor = color;
  }

  const containerDimensionsPx = variant === 'sm' ? 16 : 24;

  return (
    <Box
      height={containerDimensionsPx}
      width={containerDimensionsPx}
      bgcolor={backgroundColor}
      borderRadius="2px"
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      color={textColor}
    >
      <Typography variant="pMd" className={fontSize} color="gray_1200">
        {children}
      </Typography>
    </Box>
  );
};

export default ColorIcon;
